import {containerService} from "@/_services";

export default {
  getAll({commit}, {page, sort, search, status, start_date, end_date}) {
    return containerService.getAll(page, sort, search, status, start_date, end_date)
      .then(containers => {
        commit("setContainersData", containers);
        return Promise.resolve(containers);
      });
  },
  createContainer(_, container) {
    return containerService.create(container);
  },
  deleteContainer(_, {container}) {
    return containerService.deleteContainer(container.uuid);
  },
  getContainer(_, uuid) {
    return containerService.getById(uuid);
  },
  getResume(_, uuid) {
    return containerService.getResume(uuid);
  },
  addDocument(_, {uuid, file}) {
    return containerService.addDocument(uuid, file);
  },
  getDocuments(_, {uuid, search, status}) {
    return containerService.getDocuments(uuid, search, status);
  },
  updateContainer(_, {uuid, data}) {
    return containerService.update(uuid, data);
  },
  downloadAll(_, uuid) {
    return containerService.downloadAll(uuid);
  },
  getUploadProcesses(_, uuid) {
    return containerService.getUploadProcesses(uuid);
  }
}
